import { Link } from 'react-router';
import { Sword, Lock, Scroll, Users } from 'lucide-react';
import { Header, LeagueMaxPrize, Modal } from '../../components';

import './home.css';
import { ROUTES } from '../../routes';
import { LEAGUES } from '../../leagues';
import { colors } from '../../styles';
import { getClanInvitation, useIsClanMember, useSound } from '../../hooks';
import { useEffect, useState } from 'react';
import { ClanJoin } from '../clan';

const Home = () => {
  const { play } = useSound();
  const { hasJoined } = useIsClanMember();
  const code = getClanInvitation();

  const [isConfirmInvitationOpen, setConfirmInvitationOpen] =
    useState<boolean>(false);

  useEffect(() => {
    if (code) {
      setConfirmInvitationOpen(!hasJoined);
    }
  }, [hasJoined, code]);

  return (
    <div className="home">
      <Modal
        close={() => setConfirmInvitationOpen(false)}
        isOpen={isConfirmInvitationOpen}
        onCancel={() => setConfirmInvitationOpen(false)}
      >
        <ClanJoin code={code ?? ''} />
      </Modal>

      <Header />

      <div className="home-container">
        <section className="home-nav">
          <Link
            to={ROUTES.MY_COLLECTIONS}
            target="_top"
            className="nav-card purple"
            onClick={() => play('vaultEcho')}
          >
            <div className="nav-card-content">
              <div className="nav-icon">
                <Scroll />
              </div>
              <div>
                <h2>Mis Colecciones</h2>
                <p>Revisa tus tarjetas conquistadas</p>
              </div>
              <span className="arrow">→</span>
            </div>
          </Link>

          <Link
            to={ROUTES.CLAN}
            target="_top"
            className="nav-card cyan"
            onClick={() => play('clanBanner')}
          >
            <div className="nav-card-content">
              <div className="nav-icon">
                <Users stroke={colors.page} />
              </div>
              <div>
                <h2>Mi Clan</h2>
                <p>Gestiona tus aliados y referidos</p>
              </div>
              <span className="arrow">→</span>
            </div>
          </Link>
        </section>

        {/* LEAGUES */}
        <section className="home-leagues">
          <h3 className="section-title">
            <Sword className="icon sword" stroke={colors.third} />
            Ligas de Batalla
          </h3>

          <div className="league-grid">
            {LEAGUES.map((league) =>
              league.active ? (
                <Link
                  key={league.id}
                  to={`${ROUTES.LEAGUE}/${league.path}`}
                  target="_top"
                  className="league-card active"
                  style={
                    {
                      '--league-bg': league.bgColor,
                      '--league-border': league.borderColor,
                    } as React.CSSProperties
                  }
                >
                  <div className="league-header">
                    <div
                      className="league-icon"
                      style={{ backgroundColor: league.bgColor }}
                    >
                      <span>{league.icon}</span>
                    </div>

                    <div className="league-info">
                      <h2>Liga {league.name}</h2>
                      {/* <CompactTimer /> */}
                    </div>
                  </div>

                  {league?.description && (
                    <p className="league-desc">{league.description}</p>
                  )}

                  <div className="league-prize">
                    <LeagueMaxPrize league={league} />
                  </div>

                  <div className="league-enter">
                    Entrar a la Liga <span>→</span>
                  </div>
                </Link>
              ) : (
                <div
                  key={league.id}
                  className="league-card inactive"
                  style={
                    {
                      '--league-bg': league.bgColor,
                      '--league-border': league.borderColor,
                    } as React.CSSProperties
                  }
                >
                  <div className="badge">Próximamente</div>

                  <div className="league-header">
                    <div className="league-icon muted">
                      <span>{league.icon}</span>
                      <Lock className="lock" stroke={colors.secondary} />
                    </div>

                    <h2 className="muted-text">Liga {league.name}</h2>
                  </div>

                  {league?.description && (
                    <p className="league-desc muted-text">
                      {league.description}
                    </p>
                  )}

                  <div className="league-prize muted">
                    <LeagueMaxPrize league={league} />
                  </div>

                  <div className="league-locked">
                    <Lock /> Bloqueada
                  </div>
                </div>
              ),
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;
